export const BANNER_STARS_TEST_ID = 'BANNER_STARS_TEST_ID';
export const FULL_STARS_TEST_ID = 'FULL_STARS_TEST_ID';
export const ONE_STAR_TEST_ID = 'ONE_STAR_TEST_ID';
